export const SET_ONBOARDING_NEEDED = 'SET_ONBOARDING_NEEDED';
export const ADD_TO_USER_HISTORY = 'ADD_TO_USER_HISTORY';
